module.exports = __webpack_public_path__ + "slider-fabbrica.jpg?3b056623d406131ff8991417e50ee5dd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-fabbrica.jpg
// module id = 39
// module chunks = 0